import { apiClient } from "./ApiClient";

export async function fetchRolesAdmin({
  skip = 0,
  limit = 50,
  sort_by = "id",
  sort_order = "asc",
  filters = {},
}) {
  const params = new URLSearchParams({
    skip: String(skip),
    limit: String(limit),
    sort_by,
    sort_order,
  });

  if (filters.id) params.set("id", String(filters.id));
  if (filters.name) params.set("name", String(filters.name));

  try {
    const response = await apiClient.get(`/role/batch?${params.toString()}`);
    const data = response.data;

    return {
      items: data.items || [],
      total: data.total ?? (data.items ? data.items.length : 0),
      filtered: null,
    };
  } catch (error) {
    const text = error.response?.data?.detail || error.message;
    throw new Error(`fetchRolesAdmin failed: ${text}`);
  }
}

export async function createRole({ name, cutoff, rate }) {
  try {
    const payload = {
      name,
      cutoff,
      rate,
    };

    const response = await apiClient.post("/role/", payload);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to create role");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}
